import {ASK_USER_TO_ENABLE_PUSH} from './actionsTypes';

import {fetchDeviceTokenForUser} from '../../utils/util';

export const loadUserDevicePushToken = (oktaUserId) => async (dispatch) => {
  try {
    let checkForToken = false;
    const lastAskedForConfirmation = localStorage.getItem('lastAsked');
    const TWENTY_NINE_DAYS_MS = 2505600000;

    if (lastAskedForConfirmation) {
      const timeDiff =
        new Date().getTime() - parseInt(lastAskedForConfirmation);
      if (timeDiff > TWENTY_NINE_DAYS_MS) {
        checkForToken = true;
      }
    } else {
      checkForToken = true;
    }

    if (checkForToken) {
      const deviceTokens = await fetchDeviceTokenForUser(oktaUserId);

      if (!deviceTokens || deviceTokens.length === 0) {
        dispatch({type: ASK_USER_TO_ENABLE_PUSH, data: true});
      } else {
        dispatch({type: ASK_USER_TO_ENABLE_PUSH, data: false});
      }
    } else {
      console.log('Skipping modal check - asked recently');
    }
  } catch (error) {
    console.error('Error in loadUserDevicePushToken:', error);
    dispatch({type: ASK_USER_TO_ENABLE_PUSH, data: false});
  }
};
